import { PrizeType } from './prize-delivery.model';

export interface HowToPlayStep {
  title: string;
  src: string;
  description: string;
}

export enum TicketTabs {
  Tickets = 'tickets',
  Description = 'description'
}

export enum IGEvent {
  GAME_START = 'GAME_START',
  GAME_COMPLETE = 'GAME_COMPLETE'
}

export enum IGEventResult {
  WIN = 'WIN',
  LOSE = 'LOSE'
}

export enum IGEventCTA {
  PRIZE = 'PRIZE',
  REPLAY = 'REPLAY'
}
export interface IGMessages {
  event: IGEvent;
  result: IGEventResult;
  tickets: IGEventTicket[];
  ticket: IGEventTicket;
  cta: IGEventCTA;
}

export interface IGPlaying {
  iframe: IGIframe;
  tickets: IGTicket[];
  remainingTickets: number;
}

export interface IGPrizeDelivery {
  slug: string;
  orderId: number;
  orderItems: IGOrderItem[];
}

export interface IGOrderItem {
  id: number;
  raffleId: number;
  type: IGOrderItemType;
}

export enum IGOrderItemType {
  IGAMING = 'igaming',
  INSTANT_WIN = 'instant-win',
  NORMAL = 'normal'
}

export interface IGIframe {
  iframeUrl: string;
  sessionId: string;
}
export interface IGResponse<T> {
  data: T;
  errors: null;
  message: string;
  status: string;
}

export interface IGTicket {
  id: string;
  raffleTicketId: number;
  sessionId: string;
  gameId: number;
  userId: number;
  createdAt: string;
  played: boolean;
  processed: boolean;
  prize: IGPrize | null;
}

export interface IGResponseTickets {
  tickets: IGEventTicket[];
}

export interface IGEventTicket {
  id: string | null;
  tier: number;
  played: boolean;
  prize: IGEventPrize | null;
}

export interface IGEventPrize {
  id: number;
  type: string;
  value: string;
  available: null;
  amount: null;
  name: string;
  description: string | null;
  prizeTier: number;
  imgUrl: string | null;
  extraCash: null;
  ticketPrizeQuantity: null;
  instantWinGroupId: number;
}

export interface IGPrize {
  id: string;
  type: string;
  value: string;
  available: number;
  amount: number;
  name: string;
  description: string;
  prizeTier: number;
  imgUrl: string;
  instantWinGroupId: number;
}

export interface IGPrizeList {
  prizes: IGPrize[];
}

export interface IGTicketUnplayed {
  raffleTicketId: number;
  gameId: number;
}

export interface PrizeDeliveryDialogData {
  orderItem: IGOrderItem;
  orderId: number;
  slug: string;
  prizes: string[];
  siteCredit: number;
  nextIgaming: string[];
  nextInstantWin: string;
}

export interface PrizeSiteCredit {
  id: number;
  prizeType: PrizeType;
  value: string;
  wonUserId: number;
}

export enum PrizeDialogCloseStatus {
  NextIgaming = 'nextIgaming',
  EnterAgain = 'enterAgain'
}
